import { AppState } from '../state/AppState';

export function selectAssetListItems(state: AppState) {
  return state.assetList.items;
}
